// Disponibilidad de «Cancelar venta» en el detalle del backoffice, con la excepción LATE_CANCEL.
import type { BackofficeSale } from '@/api/services/retail-wizard/contract';
import {
    cancelAvailability as availabilityOf,
    type CancelAvailability,
    type SaleDetailStatus,
    type Translate,
} from '@/shared/patterns/CancelSale';

export type { CancelAvailability, SaleDetailStatus };

/** Decide el botón con el detalle de la venta; sin `cancellation` (backend viejo) queda activo. */
export function cancelAvailability(
    sale: BackofficeSale,
    detailStatus: SaleDetailStatus,
    t: Translate,
): CancelAvailability {
    return availabilityOf(sale.cancellation, detailStatus, t, 'backoffice');
}
